import { useEffect } from 'react';

/**
 * Hook to allow easy binding of a callback to a click outside of a container
 * @param outerContainerRef - Your outer container (document?)
 * @param componentRef - Your component, clicks inside of this will not trigger callback
 * @param callback - Your callback function
 */
export const useOutsideClick = (
  outerContainerRef: HTMLElement | undefined | null,
  componentRef: HTMLElement | undefined | null,
  callback: () => void
) => {
  /**
   * if clicked inside of outerContainerRef, but outside of componentRef, fire callback
   */
  const handleClickOutside = (event: MouseEvent) => {
    if (outerContainerRef?.contains(event.target as Node) && !componentRef?.contains(event.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
};
